<template>
  <span
    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
    :class="statusClasses"
  >
    <slot>{{ status?.replace("_", " ") }}</slot>
  </span>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const statusClasses = computed(() => {
  const classes = {
    Active: "bg-green-100 text-green-800 border border-green-600",
    Inactive: "bg-red-100 text-red-800 border border-red-600",
    Pending: "bg-yellow-100 text-yellow-800 border border-yellow-600",
    "In Progress": "bg-blue-100 text-blue-800 border border-blue-600",
    Completed: "bg-green-100 text-green-800",
    Rejected: "bg-red-100 text-red-800 border border-red-600",
    Pending_review: "bg-orange-100 text-orange-800",
    Verified: "bg-green-100 text-green-800 border border-green-600",
  };

  return classes[props.status] || "bg-gray-100 text-gray-800";
});
</script>
